export default "__VITE_ASSET__EAluTNhk__"